// Lightweight GA4-style analytics wrapper. If GA4 ID is set, we forward events to gtag.
// Always mirrors events to the backend for top-product analytics.
import api from "./api";

/** Same product can emit view_item several times per real visit (Strict Mode, emergent-main.js duplicate API traffic, etc.). Drop duplicates within this window for GA + backend. */
const VIEW_ITEM_DEDUP_MS = 8000;
const lastViewItemSentAt = new Map();

function gtagSafe() {
    if (typeof window === "undefined") return null;
    return window.gtag || null;
}

export function pageView(path, title) {
    const gtag = gtagSafe();
    if (gtag) gtag("event", "page_view", { page_path: path, page_title: title });
}

export function track(eventName, params = {}) {
    if (eventName === "view_item") {
        const pid = params?.item_id || params?.productId;
        if (pid) {
            const now = Date.now();
            const prev = lastViewItemSentAt.get(pid);
            if (prev !== undefined && now - prev < VIEW_ITEM_DEDUP_MS) {
                return;
            }
            lastViewItemSentAt.set(pid, now);
        }
    }

    const gtag = gtagSafe();
    if (gtag) gtag("event", eventName, params);

    // Forward server-relevant events to backend
    const serverEvents = new Set([
        "view_item", "select_item", "view_item_list", "buy_now_click",
        "whatsapp_click", "add_to_wishlist", "search", "login", "sign_up", "admin_login",
    ]);
    if (serverEvents.has(eventName)) {
        api.post("/analytics/event", {
            eventName,
            productId: params.item_id || params.productId,
            productName: params.item_name || params.productName,
            category: params.item_category || params.category,
            price: params.price,
            listName: params.list_name || params.listName,
            meta: params,
        }).catch(() => {});
    }
}

export function buildWhatsappLink({ number, template, product }) {
    const msg = (template || "Hi Loomara, I'm interested in {product_name} priced at ₹{price}.")
        .replace("{product_name}", product?.name || "your collection")
        .replace("{price}", product?.price ?? "")
        .replace("{category}", product?.category || "");
    return `https://wa.me/${number}?text=${encodeURIComponent(msg)}`;
}
